/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  IconButton,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import { IsInRole } from 'shared/authorization/IsInRole';
import { Roles } from 'shared/enums/Roles';
import UserOrganizationInfo from '../userOrganizationSection/UserOrganizationInfo';

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 275,
    padding: '1rem',
    marginBottom: '2rem',
    marginTop: '2rem',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  divider: {
    marginBottom: '2.125rem',
  },
}));

function UserOrganizationDetails({
  userRoles,
  onSubmit,
  onRoleChange,
  editRoles,
  editRole,
  handleEditRoles,
  showActionButton,
  disabled,
  onClick,
  userId,
  currentOrganization,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Box className={classes.cardHeader}>
          <Typography className={classes.title} color="textPrimary" gutterBottom>
            {t('user.management.organization')}
          </Typography>
          <IsInRole roles={[Roles.END_USER_ADMIN]}>
            {showActionButton && (
              <CardActions>
                {editRoles && !editRole ? (
                  <IconButton
                    data-testid="openEditUserRoles"
                    aria-label={t('actions.edit')}
                    name="openEditUserRoles"
                    color="primary"
                    onClick={handleEditRoles}
                  >
                    <EditIcon />
                  </IconButton>
                ) : (
                  <>
                    <Button
                      data-testid="editUserRoles"
                      name="editUserRoles"
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      startIcon={<SaveIcon />}
                      onClick={onSubmit}
                      disabled={disabled}
                    >
                      {t('save.changes')}
                    </Button>
                  </>
                )}
              </CardActions>
            )}
          </IsInRole>
        </Box>
        <Divider />
        {/* <CardContent> */}
        <UserOrganizationInfo
          showActionButton={showActionButton}
          onRoleChange={onRoleChange}
          userRoles={userRoles}
          editMode={editRole}
          editRole={editRole}
          onClick={onClick}
          userId={userId}
          currentOrganization={currentOrganization}
        />
      </CardContent>
    </Card>
  );
}

export default UserOrganizationDetails;
